import { useNavigate } from 'react-router-dom'
import Button from '../../common/Button/Button'

/**
 * Header Component
 * Portal header with logo, user profile, and optional logout
 *
 * @param {Object} props
 * @param {Object} props.user - User object { displayName, email, role, photoURL }
 * @param {Function} props.onLogout - Logout handler function
 * @param {boolean} props.showBackButton - Show back navigation button
 * @param {Function} props.onBack - Back button handler (defaults to history.back)
 * @param {string} props.title - Header title text
 */
const Header = ({
  user,
  onLogout,
  showBackButton = false,
  onBack,
  title = 'PsyberNova Portal'
}) => {
  const navigate = useNavigate()

  // Handle back navigation
  const handleBack = () => {
    if (onBack) {
      onBack()
    } else {
      window.history.back()
    }
  }

  // Handle change password navigation
  const handleChangePassword = () => {
    navigate('/change-password')
  }

  return (
    <header className="psyber-header">
      {/* Logo Section */}
      <div className="psyber-logo-section">
        {/* Back Button (optional) */}
        {showBackButton && (
          <button
            className="psyber-back-btn"
            onClick={handleBack}
            aria-label="Go back"
          >
            <i className="fas fa-arrow-left"></i>
          </button>
        )}

        {/* Title */}
        <h1 className="psyber-title-gradient">{title}</h1>
      </div>

      {/* User Profile Section */}
      {user && (
        <div className="psyber-user-profile">
          {/* User Info */}
          <div className="user-welcome">
            <p>
              <strong>Welcome, {user.displayName || 'User'}</strong>
            </p>
            <p className="psyber-text-secondary">
              {user.role || 'Employee'} • {user.email || ''}
            </p>
          </div>

          {/* User Avatar */}
          <div className="psyber-avatar">
            <img
              src={user.photoURL || 'https://i.pravatar.cc/150?img=12'}
              alt={`${user.displayName || 'User'} avatar`}
            />
            <div className="psyber-status-dot"></div>
          </div>

          {/* Change Password Button */}
          <Button
            variant="ghost"
            icon="fas fa-key"
            onClick={handleChangePassword}
            className="psyber-change-password-btn"
            style={{
              marginLeft: 'var(--psyber-space-sm)',
              padding: '0.5rem 1rem'
            }}
          >
            Change Password
          </Button>

          {/* Logout Button (optional) */}
          {onLogout && (
            <Button
              variant="ghost"
              icon="fas fa-sign-out-alt"
              onClick={onLogout}
              className="psyber-logout-btn"
              style={{
                marginLeft: 'var(--psyber-space-sm)',
                padding: '0.5rem 1rem'
              }}
            >
              Logout
            </Button>
          )}
        </div>
      )}
    </header>
  )
}

export default Header
